import { AxiosInstance, AxiosStatic } from 'axios'
import { ApiRoutesNames } from 'bets.oddprovider.lib.common.ts/api/routes'
import { IBetSettlement } from 'bets.oddprovider.lib.common.ts/models'
import { BaseApiClient } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { store } from '../redux/store'

export class BetsSettlementsApiClient extends BaseApiClient<IBetSettlement, any, FilterQuery<IBetSettlement>, IBetSettlement, IBetSettlement> {
  constructor(axios: AxiosStatic | AxiosInstance) {
    const dotEnvProductionState = store.getState().dotEnvProductionState
    const baseUrl = `${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.betsSettlements}`
    super({
      apiUrl: baseUrl,
      axios,
    })
  }
}